export enum CommunicationTypes {
  ETHERNET = "Network port",
  SERIAL = "RS-232 serial port"
}
